"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.3915 12.0234H6.60851C6.06751 12.0234 5.79651 11.4154 6.17951 11.0594L9.57051 7.18837C9.80751 6.96737 10.1925 6.96737 10.4295 7.18837L13.8205 11.0594C14.2035 11.4154 13.9325 12.0234 13.3915 12.0234ZM9.99951 2.00037C5.58151 2.00037 1.99951 5.58237 1.99951 10.0004C1.99951 14.4184 5.58151 18.0004 9.99951 18.0004C14.4185 18.0004 17.9995 14.4184 17.9995 10.0004C17.9995 5.58237 14.4185 2.00037 9.99951 2.00037Z",
    fill: "#727B7F"
  }));
};